/*
 * @Descripttion:
 * @Version: 1.0
 * @Author: cjy
 * @Date: 2023-07-22 15:52:44
 * @LastEditors: cjy
 * @LastEditTime: 2024-04-01 19:09:26
 */
import dsBridge from 'dsbridge';
const dsBridgeCall = (funcName, params, callBack) => {
  if (params) {
    params = (typeof params === 'string') ? params : JSON.stringify(params);
  } else {
    params = '';
  }
  if (dsBridge.hasNativeMethod(funcName)) {
    if (callBack) {
      return dsBridge.call(funcName, params, callBack);
    } else {
      return dsBridge.call(funcName, params);
    }
  } else {
    return '';
  }
};
const unionJsBridge = {
  startNewWebViewPage(url) { // finishCurrent是否关闭当前webview
    dsBridgeCall('startNewWebViewPage', { url, finishCurrent: false });
  },
  // 获取appToken
  getAppToken() { // callBack 为路由钩子中的next
    return new Promise((resolved) => {
      const token = dsBridgeCall('getUserToken') || '';
      resolved(token);
    });
  },
  getRegisterId(callBack) {
    const registerId = dsBridgeCall('getRegisterId') || '';
    callBack && callBack(registerId);
  },
  setNavRightBtn(param = {}, callBack) {
    dsBridgeCall('setNavRightBtnList', param);
    dsBridge.register('rightButtonClicked', (item) => {
      callBack && callBack(item);
    });
  },
  showNavSuperposedView(param = [], callBack) {
    dsBridgeCall('showNavSuperposedView', param, (item) => {
      callBack && callBack();
    });
  },
  setWebpageSettingInfo(params = {}) {
    const {
      isIntercept = false, isUpload = false,
    } = params;
    dsBridgeCall('setWebpageSettingInfo', {
      modelName: params.title,
      isIntercept,
      isUpload,
      interceptDesc: '合同涉及敏感信息，为了您的信息安全，请联系客服获取',
    });
  },
  // 隐私政策或服务协议跳转至第三方页面时隐藏app头部右侧按钮（查看历史版本的右侧点号按钮）
  hideNavRightBtn() {
    dsBridgeCall('setNavRightBtnList', []);
  },
  getLoginMobile() {
    return dsBridgeCall('getLoginMobile');
  },
  // 获取app版本号
  getAppVersionInfo() {
    // android
    return JSON.parse(dsBridgeCall('getAppVersionInfo') || '{}');
  },
  /**
   * 获取app渠道
   */
  getAppChannel() {
    const { platform } = this.getAppVersionInfo();
    if (platform !== 'ios') {
      const appChannel = dsBridgeCall('getAppChannel');
      if (appChannel) {
        return JSON.parse(appChannel).channel;
      }
    }
  },
};
export default unionJsBridge;
